import unescapeJs from 'unescape-js'
import _ from 'lodash'
import i18n from '@/i18n.js'
export const JSON_FORMATTER = function (text) {
    try {
      let unescaped = unescapeJs(text)

      if (unescaped.charAt(0) === '"' && unescaped.charAt(unescaped.length - 1) === '"') { unescaped = unescaped.substr(1, unescaped.length - 2) }

      const parsed = JSON.parse(unescaped)

      return JSON.stringify(parsed, null, 4)
    } catch {
      return text
    }
  }

  export const convertUTCToLocal = function (ds, mode) {
    if (!ds) return ''
    var date = this.$moment.utc(ds, 'YYYY-MM-DDHH:mm:ss.SSS"')

    switch (mode) {
      case 'date':
        return date.local().format('L')
      case 'time':
        return date.local().format('LT')
      default:
        return `${date.local().format('L')} ${date.local().format('LT')}`
    }
  }

  export const currencyConvert = function (fromValue, fromCurrency, toCurrency) {
    if (fromCurrency.name === toCurrency.name) { return fromValue }

    if (fromCurrency != null && toCurrency != null) { return parseFloat(fromValue * (fromCurrency.rate_from / toCurrency.rate_to), 2) } else { return fromValue }
}

  export const calculatePrice = function (priceline, priceGroup) {
    let salesPriceSurcharge = 0
    let salesPricePercentage = 0
    let salesPrice = null
    const cost = priceline.cost

    /* _.each(priceline.products, p => {
      cost += currencyConvert(p.final_cost, p.agreement.currency, priceline.currency)
    }) */

    // If it belongs to a pricegroup. Use the predefined pricing model from the pricegroup.
    if (priceGroup) {
      salesPriceSurcharge = priceGroup.sales_price_surcharge || 0
      salesPricePercentage = priceGroup.sales_price_percentage || 0
      salesPrice = priceGroup.sales_price
    }

    // Override if the price have an alternative price
    salesPriceSurcharge = priceline.sales_price_surcharge || salesPriceSurcharge
    salesPricePercentage = priceline.sales_price_percentage || salesPricePercentage
    salesPrice = priceline.sales_price || salesPrice

    if (salesPrice) {
      priceline.final_price = parseFloat(salesPrice || 0)
     // priceline.cost = parseFloat(cost || 0)

      priceline.margin = priceline.final_price - priceline.cost
      return priceline
    }

    salesPrice = cost
    if (salesPricePercentage) { salesPrice += (cost * (parseFloat(salesPricePercentage || 1) / 100)) }
    if (salesPriceSurcharge) { salesPrice += parseFloat(salesPriceSurcharge || 0) }

    priceline.margin = !salesPrice ? salesPrice : salesPrice - cost
    priceline.final_price = parseFloat(salesPrice || 0)

    return priceline
  }

  export const emptyPriceObject = {
    active: false,
    name: '',
    carrier_product_services: [],
    transit: null,
    linehaul_products: null,
    sales_price_surcharge: null,
    sales_price_percentage: null,
    sales_price: null,
    dimension: null,
    weight_from: null,
    weight_to: null,
    from_country: { id: 194, iso: 'DK', full_name: 'Denmark' },
    to_country: { id: 194, iso: 'DK', full_name: 'Denmark' },
    products: [],
    cost: null,
    calculation: '',
    margin: null,
    final_price: null,
    currency: { id: 1, name: 'DKK', full_name: 'Dansk Krone' },
    supports_app: false,
    has_insurance: false,
  }

  export const priceHeaders = [
    {
      sortable: false,
      value: 'active',
    },
    {
      sortable: false,
      text: i18n.t('name'),
      value: 'name',
    },
    {
      sortable: false,
      text: 'CPS',
      value: 'carrier_product_services',
    },
    {
      sortable: false,
      text: i18n.t('products'),
      value: 'products',
    },
    {
      sortable: false,
      text: i18n.t('transit'),
      value: 'transitProduct',
    },
    {
      sortable: false,
      text: i18n.t('linehaul'),
      value: 'linehaul_products',
    },
    {
      sortable: false,
      text: i18n.t('geo'),
      value: 'geo',
    }, {
      sortable: false,
      text: i18n.t('weight'),
      value: 'weight',
    },
    {
      sortable: false,
      text: 'LxBxH',
      value: 'dimension',
    },
    {
      sortable: false,
      text: i18n.t('currency'),
      value: 'currency',
    }, {
      sortable: false,
      text: i18n.t('cost_price'),
      value: 'cost',

    }, {
      sortable: false,
      text: i18n.t('sales_price'),
      value: 'sales_price',
    }, {
      sortable: false,
      text: i18n.t('surcharge', { suffix: '' }),
      value: 'sales_price_surcharge',
    }, {
      sortable: false,
      text: i18n.t('surcharge', { suffix: '%' }),
      value: 'sales_price_percentage',
    }, {
      sortable: false,
      text: i18n.t('margin'),
      value: 'margin',
    }, {
      sortable: false,
      text: i18n.t('app'),
      value: 'supports_app',
      align: 'center',
    }, {
      sortable: false,
      text: i18n.t('insurance'),
      value: 'has_insurance',
      align: 'center',
    },
    { value: 'action', align: 'right', sortable: false },
  ]
